import React, { useState } from 'react';
import FadeCollapse from 'components/FadeCollapse/FadeCollapse';

import { type MenuOption } from 'generated/graphql';

import OptionGroupItem from './OptionGroupItem';

import styles from './Details.module.scss';

interface Props {
  optionGroup?: MenuOption | undefined | null;
}

const OptionGroup: React.FC<Props> = ({ optionGroup }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  if (!optionGroup) {
    return null;
  }

  const { posId, name, variants } = optionGroup;

  return (
    <li key={posId} data-testid="optionGroup-container">
      <h4>
        <button
          onClick={() => (isOpen === true ? setIsOpen(false) : setIsOpen(true))}
          className={isOpen ? styles.Open : ''}
          type="button"
          tabIndex={0} // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
        >
          {name}
          {variants && (
            <span data-testid="optionGroup-variants-text">
              {variants.length} option{variants.length === 1 ? '' : 's'}
            </span>
          )}
          <i className="mm-angle-down" />
        </button>
      </h4>
      <FadeCollapse open={isOpen}>
        <OptionGroupItem optionGroup={optionGroup} />
      </FadeCollapse>
    </li>
  );
};

export default OptionGroup;
